// extracted by mini-css-extract-plugin
module.exports = {"item":"EditCard_style_item__2VQfs","del":"EditCard_style_del__2MIHR","edit-div":"EditCard_style_edit-div__2R9uX","expend":"EditCard_style_expend__2tMeD"};